import api from './api'

const imaginaryCompanyBasePath = '/api/v1/fund-map/imaginary-company'

export async function getAllImaginaryCompany() {
  const resp = await api.get(`${imaginaryCompanyBasePath}`)
  return resp.data
}

export async function getImaginaryCompanyByCompanyId(companyId) {
  const resp = await api.get(`${imaginaryCompanyBasePath}/${companyId}`)
  return resp.data
}

export async function saveImaginaryCompany(companyData, userId) {
  const resp = await api.post(`${imaginaryCompanyBasePath}`, { companyData: companyData, userId })
  return resp.data
}

export async function patchImaginaryCompanyById(imaginaryCompanyId, companyData) {
  const resp = await api.patch(`${imaginaryCompanyBasePath}/${imaginaryCompanyId}`, { companyData })
  return resp.data
}

export async function patchImaginaryUserCompanyById(userCompanyId, data) {
  const resp = await api.patch(`${imaginaryCompanyBasePath}/user-imaginary-company/${userCompanyId}`, {
    favoriteCompetitionIds: data
  })
  return resp.data
}

export async function deleteImaginaryCompanyById(imaginaryCompanyId) {
  const resp = await api.delete(`${imaginaryCompanyBasePath}/${imaginaryCompanyId}`, imaginaryCompanyId)
  return resp.data
}
